import React, { memo, useMemo } from 'react';
import SVG from 'react-inlinesvg';
import SideBarItem from '../SideBarItem';
import UserContentAvatar from '../UserContentAvatar';
import { useTranslation } from 'react-i18next';
import { mavigpsSVG, logoutSVG } from '../../../shared/helpers/icons';
import { sidebarItems } from '../../routes';
import { isCommercialRole } from '../../helpers/loggedUser';
import styles from './sideBar.module.scss';

const SideBar = ({
    currentChildRoute,
    changeConfigChildRoute,
    setUserLogin,
    loggedUser,
    signOut,
    locationPathName
}) => {
    const { t } = useTranslation('home');

    const chageChildRoute = route => { };

    const logout = () => {
        signOut();
    };

    // Reorder routes for commercial users - put ActiveServices first
    const orderedRoutes = useMemo(() => {
        return sidebarItems;
    }, []);

    return (
        <div className={styles.sideBar}>
            <div className={styles.header}>
                <div className={`${styles.itemsContent} ${styles.itemsContentBrand}`}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SVG src={mavigpsSVG}></SVG>
                        </div>
                        <div className={`${styles.title} ${styles.titleBrand}`}>{t('administration')}</div>
                    </div>
                </div>
            </div>
            <div className={styles.body}>
                <div>
                    {orderedRoutes.map(route => {
                        return (
                            <SideBarItem
                                key={route.path}
                                route={route}
                                action={chageChildRoute}
                                currentChildRoute={currentChildRoute}
                                loggedUser={loggedUser}
                                locationPathName={locationPathName}
                            />
                        );
                    })}
                </div>
            </div>

            <div className={styles.footer}>
                <UserContentAvatar loggedUser={loggedUser} />
                <SideBarItem
                    route={{
                        icon: logoutSVG,
                        title: {
                            key: t('sign_out')
                        },
                        path: '/login'
                    }}
                    action={logout}
                    styles={styles}
                    locationPathName={locationPathName}
                    loggedUser={loggedUser}
                />
            </div>
        </div>
    );
};

export default memo(SideBar);
